import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AuthUserData } from './models/auth.store';

export const selectAuth = createFeatureSelector<AuthUserData>('auth');

export const selectAuthValue = createSelector(
    selectAuth,
    (state: AuthUserData) => state,
);
